import React from "react";
import { STRINGS } from "../../../../../strings";
import { translate } from "../../../../../translate";
import { AppSlider } from "../../../../Generic/AppSlider";

export interface Props {
  riskLevel: number | null;
  notes: string | null;
  onSetQuestionRisk: (value: number) => void;
  onSetQuestionNotes: (value: string) => void;
  onVBPQuestionNotesClick: (vbpQustionNotesAreOpen: boolean) => void;
}

const VBPQuestionExtraDetails = (props: Props) => {
  const disableScroll = () => {
    document.ontouchmove = (e) => {
      e.preventDefault();
    };
  };

  const enableScroll = () => {
    document.ontouchmove = () => {
      return true;
    };
  };

  return (
    <div className="VBPQuestionCard__openVBPContent">
      <div className="VBPQuestionCard__riskSliderContainer">
        <span>{translate(STRINGS.HOW_URGENT_IS_THE_ISSUE)}</span>
        <div className="VBPQuestionCard__riskSlider">
          <AppSlider
            onBeforeChange={() => disableScroll}
            onAfterChange={() => enableScroll}
            withBars={true}
            max={3}
            min={1}
            value={props.riskLevel === null ? 1 : props.riskLevel}
            step={1}
            snapDragDisabled={true}
            onChange={(value) => {
              if (typeof value !== "number") {
                throw new Error("The Impossible Happened");
              }
              props.onSetQuestionRisk(value);
            }}
            startHandler={{
              direction: "start",
              children: props.riskLevel === null ? 1 : props.riskLevel,
            }}
          />
          <div className="VBPQuestionCard__riskSlider_axisLegend">
            <span>{translate(STRINGS.NOT_URGENT)}</span>
            <span>{translate(STRINGS.VERY_URGENT)}</span>
          </div>
        </div>
      </div>
      <div className="VBPQuestionCard__notesContainer">
        <span>{translate(STRINGS.DESCRIBE_THE_PROBLEM)}</span>
        <textarea
          rows={4}
          cols={50}
          wrap="physical"
          onFocus={() => props.onVBPQuestionNotesClick(true)}
          onBlur={() => props.onVBPQuestionNotesClick(false)}
          className={"MedicationCard__notesInput"}
          value={props.notes !== null ? props.notes : ""}
          placeholder={translate(STRINGS.HOW_DOES_PATIENT_FEEL_WHAT_MAIN_SYMPTOMS)}
          onChange={(event) => props.onSetQuestionNotes(event.target.value)}
        />
      </div>
    </div>
  );
};

export default React.memo(VBPQuestionExtraDetails);
